module.exports = class StepButtonsCollection extends Backbone.Collection
    model: require 'models/step-button'

    getLeftButtons: ->
        @filter((button) -> button.isVisible() and button.isLeftAligned())

    getRightButtons: ->
        @filter((button) -> button.isVisible() and button.isRightAligned())
